module.exports = require("mime");


//////////////////
// WEBPACK FOOTER
// external "mime"
// module id = 13
// module chunks = 0